import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";

class City extends Component {
  state = {
    rowData: [],
    loadingData: true,
  };
  componentDidMount() {
    this.getMasterData()
  }
  getMasterData = (searchTerm = '') => {
    ReadAxios({ url: "cityMaster", readItems: { searchTerm } })
      .then((dataArray) => {
        // console.log(dataArray);
        this.setState({
          rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err)
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_CITY_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  handleCustomSearch = (searchTerm) => {
    this.getMasterData(searchTerm)
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-city", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/city");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    //console.log(this.props)
    const Columns = [
      { 
        headerName: t("table_header.city_id") || "City Id", 
        field: "city_id", 
        hide: true 
      },
      {
        headerName: t("table_header.city_code") || "City Code",
        field: "cityCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.city_name") || "City Name",
        field: "cityName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        pinned: "right",
        suppressToolPanel: true,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t("title") || "City"}
          titleBarLink={"/add-city"}
          baseURL={"cityMaster"}
          pathName={"cityMaster"}
          keyIndex={"city_id"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_CITY_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_CITY_MASTER.DELETE}
          customSearch={this.handleCustomSearch}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("city")(City));
